
import {
    defineComponent, ref, reactive
} from 'vue'
import type { FormInstance, FormRules, Action } from "element-plus";
import acrdService from "@/core/services/AcrdService";
import { errManager } from "@/core/config/Tools";
import { ElMessageBox } from 'element-plus'

export default defineComponent({
    props: {
        id: {},
        target: {},
        status: {
            type: null,
            required: true,
            default: {}
        }
    },
    setup(props) {
        const loading = ref(false)
        const formRec = ref<FormInstance>()
        const form = reactive(<any>{})
        const rules = reactive<FormRules>({
            checkdoc: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            },],
            message: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            },],
        })

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid)
                    saveForm()

            });
        };

        const saveForm = async () => {
            loading.value = true
            form.idacrd = props.id
            await acrdService.changeStatus('payroll', form)
                .then((res) => {
                    loading.value = false
                    if (res.data.status) {
                        ElMessageBox.alert(res.data.message, process.env.VUE_APP_NAME, {
                            confirmButtonText: 'OK',
                            callback: (action: Action) => {
                                resetForm(formRec.value)
                            },
                        })
                    }
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        return {
            loading,
            formRec,
            form,
            rules,
            resetForm,
            submitForm,
        }

    },
})
